import { render, staticRenderFns } from "./loader-circle.vue?vue&type=template&id=24492807&scoped=true&"
var script = {}
import style0 from "./loader-circle.vue?vue&type=style&index=0&id=24492807&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24492807",
  null
  
)

export default component.exports